import { createContext, type ReactNode, useContext } from "react";

const IsPrintContext = createContext(false);

/**
 * Whether this subtree is being rendered onto paper.
 *
 * `Renderer` hands `isPrint` to elements that come from markdown, but a control built in React -- the
 * details of an error box, say -- is several components away from it, and paper has no room for something
 * a reader is supposed to click open. Asking here costs nothing and cannot be forgotten at a call site.
 */
export const useIsPrint = () => useContext(IsPrintContext);

export const PrintProvider = ({ children }: { children: ReactNode }) => (
	<IsPrintContext.Provider value={true}>{children}</IsPrintContext.Provider>
);
